import { render, staticRenderFns } from "./treeDialog.vue?vue&type=template&id=ff6138be&scoped=true"
import script from "./treeDialog.vue?vue&type=script&lang=js"
export * from "./treeDialog.vue?vue&type=script&lang=js"
import style0 from "./treeDialog.vue?vue&type=style&index=0&id=ff6138be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6138be",
  null
  
)

export default component.exports